function resizeContainer(){
  window.pageHeight = 0
  st.min = 0
  st.max = 0

  const $body = $('body')

  function calculate(){
    let newHeight = $('.mainpage').outerHeight()
    newHeight = newHeight<wh?wh:newHeight
    st.max = newHeight - wh < 0 ? 0 : newHeight - wh
    st.max = Math.floor(st.max)


    if (newHeight != pageHeight) {
      pageHeight = newHeight
      if (window.scrollType === 'native' || window.scrollType === 'lenis') return
      gsap.set($body, {height:pageHeight})
    }
  }


  bus.on('resize', function(){
    bus.emit('resizeContainer')
  })
  bus.on('resizeContainer', function(){
    calculate()
    setTimeout(calculate, 500)
  })
  calculate()
}

export default resizeContainer